import React from 'react';
import { Grid, Oss, Triple, Partnere } from './Grid';
import Img from 'gatsby-image';
import { StaticQuery, graphql } from 'gatsby';
import Formss from './kontaktForm';
import Carousel from './Karusell';

const SINGLE_IMAGE = graphql`
	{
		Eldbjorg: file(relativePath: { eq: "eldbjorg2.jpeg" }) {
			childImageSharp {
				fluid(maxWidth: 2000) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		LogoGreen: file(relativePath: { eq: "Logowhite.png" }) {
			childImageSharp {
				fluid(maxWidth: 2000) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		Utsikt: file(relativePath: { eq: "Utsikt.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 2000) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		artist: file(relativePath: { eq: "artistene.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 3000) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		innsjekk: file(relativePath: { eq: "Innsjekk.png" }) {
			childImageSharp {
				fluid(maxWidth: 200) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		Transport: file(relativePath: { eq: "Transport.png" }) {
			childImageSharp {
				fluid(maxWidth: 200) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		Koffert: file(relativePath: { eq: "Koffert.png" }) {
			childImageSharp {
				fluid(maxWidth: 200) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		danebu: file(relativePath: { eq: "hovedbilde2.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 1000) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		rom: file(relativePath: { eq: "rom.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 1000) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		mat: file(relativePath: { eq: "mat.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 1000) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		DK: file(relativePath: { eq: "DKlogo.png" }) {
			childImageSharp {
				fluid(maxWidth: 200) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		HF: file(relativePath: { eq: "HFlogo.png" }) {
			childImageSharp {
				fluid(maxWidth: 200) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		N: file(relativePath: { eq: "Nlogo.png" }) {
			childImageSharp {
				fluid(maxWidth: 200) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		VM: file(relativePath: { eq: "VM.png" }) {
			childImageSharp {
				fluid(maxWidth: 200) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		slide1: file(relativePath: { eq: "sisters.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 3000) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
	}
`;

export default function Main() {
	return (
		<StaticQuery
			query={SINGLE_IMAGE}
			render={(data) => {
				const danebu = data.danebu.childImageSharp.fluid;
				const Eldbjorg = data.Eldbjorg.childImageSharp.fluid;
				const LogoGreen = data.LogoGreen.childImageSharp.fluid;
				const Utsikt = data.Utsikt.childImageSharp.fluid;
				const artist = data.artist.childImageSharp.fluid;
				const innsjekk = data.innsjekk.childImageSharp.fluid;
				const Transport = data.Transport.childImageSharp.fluid;
				const Koffert = data.Koffert.childImageSharp.fluid;
				const rom = data.rom.childImageSharp.fluid;
				const mat = data.mat.childImageSharp.fluid;
				const DK = data.DK.childImageSharp.fluid;
				const HF = data.HF.childImageSharp.fluid;
				const N = data.N.childImageSharp.fluid;
				const VM = data.VM.childImageSharp.fluid;
				const slide1 = data.slide1.childImageSharp.fluid;
				return (
					<div>
						<Grid>
							<div>
								<Img
									fluid={Eldbjorg}
									className="pic"
									alt="Eldbjørg Hemsing ute i vakker natur med fiolinen sin"
								/>
								<p className="text3">Bilde av: Nikolaj Lund</p>
							</div>
							<div className="title">
								<p>
									Utsolgt: Velkommen til en intim og eksklusiv opplevelsesreise med høydepunktene fra
									Hemsingfestivalen samt overnatting, mat, natur og kultur fra Valdres.
								</p>
							</div>
						</Grid>
						<Oss>
							<div className="text">
								<h2>Hemsing Culture Travel</h2>
								<p>
									Hemsing Culture Travel inviterer til en eksklusiv weekend i Valdres med
									høydepunktene fra Hemsingfestivalen 2021 i kombinasjon med det beste regionen kan
									tilby av overnatting, bespisning, kulturelle inntrykk og lokalkunnskap. På ny
									inviterer Hemsing til konsertopplevelser av internasjonal klasse i intime
									omgivelser. Nyoppussede Danebu Kongsgaard, med sin fantastiske beliggenhet på
									Aurdalsåsen, tilbyr en harmonisk atmosfære, et utmerket kjøkken og et vertskap med
									sans for kvalitet. Opplevelsene vil stå i kø denne helgen.
								</p>
								<p>Velkommen til en uforglemmelig weekend sammen med oss!</p>
							</div>
							<Img fluid={LogoGreen} className="pic" alt="Hemsing Culture Travel sin logo" />
						</Oss>
						<Grid>
							<div className="text">
								<div>
									<h2 id="booking">Booking - utsolgt</h2>
									<p className="info">Ta del i denne minnerike reisen!</p>
								</div>
								<br />
								<div className="FormControl">
									<Formss />
								</div>
								<br />
								<div>
									<p className="info">
										Pris: <br /> Utsolgt <br />
									</p>
								</div>
							</div>
							<Img fluid={Utsikt} className="pic" alt="Utsikt mot Jotunheimen fra Danebu Kongsgaard" />
						</Grid>
						<Triple>
							<h2 id="program">Program:</h2>
							<div className="grid">
								<div className="program">
									<p className="title">Fredag 08.10.</p>
									<p>13:00 - 16:00: innsjekk på Danebu Kongsgaard.</p>
									<p>
										16:30: Aperitiff & bakervarer før avreise til Aurdal kirke, hvor
										åpningskonserten starter kl. 18:00.
									</p>
									<p>18:00: Åpningskonsert i Aurdal Kirke.</p>
									<p>
										20:00: Tre retters middag med nøye utvalgte spesialiteter fra Valdres og
										fjellregionen.
									</p>
								</div>
								<div className="program">
									<p className="title">Lørdag 09.10.</p>
									<p>07:30 – 09:30: Frokost på hotellet.</p>
									<p>09:30: Morgenvandring i vakre omgivelser på Aurdalsåsen.</p>
									<p>11:30: Avreise Danebu for konsert i Aurdal kirke.</p>
									<p>13:00: Lunsj på Valdres Folkemuseum.</p>

									<p>18:00: Avreise i minibuss til Nythun fjellstue for festmiddag med konsert.</p>
									<p>22:30: Retur til Danebu med minibuss.</p>
								</div>
								<div className="program">
									<p className="title">Søndag 10.10.</p>
									<p>08:00 – 10:00: Frokost på hotellet.</p>

									<p>11:30: Avreise i egne biler for avslutningskonsert i Aurdal kirke kl. 12:00.</p>
								</div>
							</div>
						</Triple>
						<Grid>
							<div className="text">
								<div>
									<h2>Artister</h2>
									<div className="artist">
										<p className="navn">Ragnhild Hemsing</p>
										<p className="instrument">Fiolin</p>
										<p className="om">
											Ragnhild Hemsing skiller seg ut blant de nye talentene i Norge som en
											uvanlig allsidig artist. Hun har dype røtter i den rike
											folkemusikktradisjonen i Norge, og det gjør henne til en av de første
											artistene som på en vellykket måte smelter sammen typiske trekk ved norsk
											folkemusikk og klassisk musikk på en ungdommelig, frisk og fullt ut moderne
											måte.
										</p>
									</div>
									<div className="artist">
										<p className="navn">Eldbjørg Hemsing</p>
										<p className="instrument">Fiolin</p>
										<p className="om">
											Eldbjørg Hemsing er en av dagens ledende unge fiolinister og en global
											ambassadør for klassisk musikk. Anerkjent for «kombinasjonen av renhet og
											feiende, Heifetz-lignende intensitet (The Strad), hennes “strålende og
											sofistikerte opptredener" (BBC Music Magazine), er hun dedikert til å få
											klassisk musikk ut til nye og yngre publikummere. Siden hun som et 5 år
											gammelt vidunderbarn dukket opp i hjemlandet Norge for 25 år siden, har hun
											raskt etablert en internasjonal karriere, spilt inn tre prisbelønte album,
											premiert flere anerkjente nye komposisjoner og opptrådd på de mest
											prestisjefylte arenaene i 15 land, inkludert Kina, USA og over hele Europa.
											Hun har spilt for Nobels Fredsprisutdeling, turnert med den norske
											kongefamilien og blitt utnevnt til en rekke kuratoriske og kunstneriske
											rådgiverroller rundt om i verden. Eldbjørg spiller på en 1707 Antonio
											Stradivari 'Rivaz, Baron Gutmann' fiolin, generøst utlånt fra Dextra
											Musica/Sparebankstiftelsen.
										</p>
									</div>
								</div>
								<div>
									<div className="artist">
										<p className="navn">Marianne Beate Kielland</p>
										<p className="instrument">Vokal</p>
										<p className="om">
											Marianne Beate Kielland er etablert som en av de fremste konserterende
											sangere i Europa, og hun er en av få norske sangere som noensinne har blitt
											nominert til US Grammy. Den allsidige mezzosopranen startet sin
											internasjonale karriere som ensemblemedlem ved statsoperaen i Hannover.
											Siden da har hun jobbet jevnlig med ledende orkestre og ensembler med et
											bredt repertoar helt fra musikk fra det 17. århundre, via klassisisme,
											romantikk og vår tids musikk.
										</p>
									</div>

									<div className="artist">
										<p className="navn">Eivind Ringstad</p>
										<p className="instrument">Bratsj</p>
										<p className="om">
											Eivind Ringstad er det nyeste talentet som har sprunget ut fra en ny gylden
											generasjon skandinaviske unge musikere. I 2016 ble han valgt til å bli med i
											verdens mest prestisjefylte treningsprogram for unge viderekommende
											klassiske musikere: BBC’s New Generation Artists Scheme.Tidligere har Eivind
											blitt tildelt Borletti-Buitoni stipendpris, og har også vært en del av
											Crescendo’s mentorprogram ledet av Leif Ove Andnes, og initiert av
											Festspillene i Bergen, Oslo Filharmoniske Orkester og Barrat Due
											Musikkinstitutt. Eivind (b.1994) begynte å spille fiolin i en alder av 5 år
											men byttet til bratsj som hovedinstrument ni år senere. Eivind spiller på en
											bratsj laget av G. Guadagnini «ex-Vieuxtemps» viola fra 1768, vennlig utlånt
											fra Dextra Musica.
										</p>
									</div>
								</div>
								<div>
									<div className="artist">
										<p className="navn">Amalie Stalheim</p>
										<p className="instrument">Cello</p>
										<p className="om">
											Amalie Stalheim (f 1993 i Bergen) er en av de mest lovende unge musikerne i
											Norden i dag. Hun er vinneren av Kungliga Musikaliska akademins store
											musikkonkurranse, Solistpriset 2018. Amalie har spilt som solist med blant
											annet Oslo filharmoniske orkester, Kungliga Filharmonien i Stockholm,
											Gulbenkian Symfoniorkester, Gøteborg symfoniorkester, Svenske
											Radioorkesteret, Bergen Filharmoniske orkester, Kringkastingsorkesteret,
											Malmø Symfoniorkester for å nevne noen. Amalie spiller på en cello bygget av
											F. Ruggieri i 1687, generøst utlånt av Anders Sveaas Almennyttige Fond.
										</p>
									</div>
									<div className="artist">
										<p className="navn">Tor Espen Aspaas</p>
										<p className="instrument">Piano</p>
										<p className="om">
											Tor Espen Aspaas (f. 1971) er en av de mest profilerte pianistene og
											musikkformidlerne i sin generasjon av norske musikere. Han ble i 2001 ansatt
											som førsteamanuensis i klaver akkompagnement og i 2006 professor ved Norges
											musikkhøgskole hvor han nå ved siden av undervisning og veiledning gjør et
											forskningsprosjekt på improvisasjonens plass i Beethovens kreative prosesser
											og verker. Han er tildelt en rekke priser og utmerkelser (bl.a. De Unges
											Lindemanpris 2004, Levinprisen 2005, Pianist Nils Larsens legat 2012).
											Aspaas ble i oktober 2016 utnevnt til Ridder 1. klasse av St. Olavs Orden.
											Aspaas har et titalls CD-utgivelser bak seg, blant disse internasjonalt
											kritikerroste solo-CD-er med verker av Beethoven, Schönberg, Berg og Webern
											samt Paul Dukas’ samlede klaververker.
										</p>
									</div>

									<div>
										<a
											href="https://en.hemsingfestival.com/artistar"
											target="_blank"
											rel="noopener noreferrer"
										>
											<p>Les mer om artistene her.</p>
										</a>
									</div>
								</div>
							</div>

							<Img
								fluid={slide1}
								className="picss"
								alt="Ragnhild og Elbjørg Hemsing i vakker vinternatur i Valdres med sine instrumenter"
							/>
						</Grid>
						<Triple>
							<div className="grid">
								<div>
									<Img fluid={innsjekk} className="pic" alt="Nøkkel ikon" />
									<p className="info">Innsjekk: fredag 08.10. mellom kl. 13.00 og 16.00.</p>
									<p className="info">Utsjekk: søndag 10.10. Inntil kl. 11.30.</p>
									<p className="info">
										Betaling: <br /> Med kort ved utsjekk på søndag.
									</p>
								</div>
								<div>
									<Img fluid={Transport} className="pic pic2" alt="Buss ikon" />
									<p className="info">
										Transport til Danebu Kongsgaard i egen bil eller med Valdresekspressen til
										Aurdal Kirke. Bilen kan parkeres kostnadsfritt på parkeringsplassen til Danebu
										Kongsgaard hvor den står trygt frem til avreise søndag.
									</p>
								</div>
								<div>
									<Img fluid={Koffert} className="pic" alt="Koffert ikon" />
									<p className="info">Anbefalt pakkeliste:</p>
									<p className="info">
										Gode uteklær etter værforhold og temperatur.<br />
									</p>
									<p className="info">
										Vanlige klær til lunsj og lunsjkonsert.<br />
									</p>
									<p className="info">
										Penere klær til middag og til kveldskonsertene.<br />
									</p>
									<p className="info">
										Toalettsaker og annet nyttig.<br />
									</p>
								</div>
							</div>
						</Triple>
						<Grid>
							<div className="text">
								<h2 id="opplevelser">Overnatting</h2>
								<p>
									Under oppholdet overnatter du på Danebu Kongsgaard, en fjellperle i Valdres sitt
									nydelige fjellandskap med en lun og innbydende atmosfære. Et sted der du kan lande
									og lade, nyte vakker natur og nydelige matopplevelser fra lokale råvarer.
								</p>
								<br />
								<p>
									Fra ditt Superior Dobbeltrom, har du en flott utsikt til Hemsedalsfjellene, Vang og
									Jotunheimen. Rommene har store og flotte bad, egen gang, fibernett, skrivebord,
									kosekrok og kaffemaskin.
								</p>
								<br />
								<a href="https://danebu.no/" target="_blank" rel="noopener noreferrer">
									<p>Les mer om Danebu Kongsgaard her.</p>
								</a>
							</div>
							<div>
								<Img fluid={danebu} className="pics" alt="Danebu Kongsgaard om høsten" />
								<Img fluid={rom} className="pics" alt="Superior dobbeltrom på Danebu Kongsgaard" />
							</div>
						</Grid>
						<Oss>
							<div className="text">
								<h2>Lokale matopplevelser</h2>
								<p>
									Kjøkkenet på Nythun og Danebu Kongsgaard tilbyr smakfulle matopplevelser basert på
									lokale råvarer og laget fra bunnen av. Ved alle måltid, fra ankomst fredag til
									avreise søndag inkludert frokost, vil du oppleve det beste Valdresregionen har å by
									på - slik som oster, spekeskinke, kurv, aure, reinsdyr og annet.
								</p>
							</div>
							<Img fluid={mat} className="pic" />
						</Oss>
						<Carousel />
						<Partnere>
							<h2>Partnere</h2>
							<div className="grid">
								<div>
									<a href="https://danebu.no/" target="_blank" rel="noopener noreferrer">
										<Img fluid={DK} className="DK pic" alt="Logoen til Danebu Kongsgaard" />
									</a>
								</div>
								<div>
									<a
										href="https://www.hemsingfestival.com/"
										target="_blank"
										rel="noopener noreferrer"
									>
										<Img fluid={HF} className="HF pic" alt="Logoen til Hemsingfestivalen" />
									</a>
								</div>
								<div>
									<a href="https://valdresmusea.no/" target="_blank" rel="noopener noreferrer">
										<Img fluid={VM} className="VM pic" alt="Logoen til Valdresmusea" />
									</a>
								</div>
								<div>
									<a href="https://www.nythun.com/" target="_blank" rel="noopener noreferrer">
										<Img fluid={N} className="N pic" alt="Logoen til Nythun" />
									</a>
								</div>
							</div>
						</Partnere>
					</div>
				);
			}}
		/>
	);
}
